import { StringParam, useQueryParams, withDefault } from "use-query-params";

export const StepLink = ({
  step,
  children,
}: {
  step: string;
  children: string;
}) => {
  const [_, setSearchParams] = useQueryParams({
    step: withDefault(StringParam, ""),
  });
  return (
    <a
      className="text-cosmic hover:text-cosmic+1"
      onClick={(e) => {
        setSearchParams({
          step,
        });
        e.preventDefault();
      }}
    >
      {children}
    </a>
  );
};
